import Auth from "./auth/reducer";
import App from "./app/reducer";
import Listings from "./CommonListing/reducer";
import AssessmentMaster from "./DashboardMaster/reducer";
import LanguageSwitcher from "./languageSwitcher/reducer";
import LocationMaster from "./LocationMaster/reducer";
import UserMaster from "./UserMaster/reducer";
import SVM from "./SystemValueMaster/reducer";
import Survey from "./Survey/reducer";
import VendorManagement from "./VendorManagement/reducer";
import AssessmentDetails from "./AddAssessment/reducer";
export default {
  Auth,
  App,
  Listings,
  LanguageSwitcher,
  LocationMaster,
  UserMaster,
  AssessmentMaster,
  SVM,
  Survey,
  VendorManagement,
  AssessmentDetails
};
